import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { DeleteIcon, EditIcon } from "../../../../assets/CommonAssets";
import SearchBar from "../../../../common/components/FormFields/SearchBar";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import CommonMasterPaginationTable from "../../../../common/components/CommonTable/CommonMasterPaginationTable";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import LoadingSpinner from "../../../../common/components/loadingspinner/loadingSpinner";
import CommonBackDrop from "../../../../common/components/CommonBackDrop/CommonBackDrop";
import ComplaintServicesModel from "./ComplaintServicesModel";
import {
  errorAlert,
  successAlert,
} from "../../../../common/components/Toasts/CustomToasts";
import { UseCheckConsecutiveCharacters } from "../../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import {
  getComplaintCategoryDeleteById,
  getComplaintCategoryFindById,
  getComplaintCategoryList,
  getSearchComplaintCategory,
} from "../../../services/complaintServices/ComplaintServicesServices";
import { useLocation } from "react-router-dom";
import {
  getComplaintServiceesList,
  getComplaintServicesDeleteById,
  getComplaintServicesFindById,
  getComplaintServicesList,
  getSearchComplaintServices,
} from "../../../services/complaintServices/ComplaintServicesServices";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";

const userActions = [
  {
    id: 0,
    permission: "Edit",
    isAction: true,
  },
  {
    id: 1,
    permission: "Delete",
    isAction: true,
  },
  {
    id: 2,
    permission: "Create",
    isAction: false,
  },
  { id: 3, permission: "View", isAction: true },
];

export default function ComplaintServices() {
  const [complaintCategoryList, setComplaintCategoryList] = useState([]);
  const [opencomplaintServicesModel, setOpeComplaiServicesModel] =
    useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [spinner, setShowSpinner] = React.useState(false);

  const [openBackdrop, setOpenBackdrop] = React.useState(false);
  const [count, setCount] = useState(0);
  const [edit, setEdit] = useState(false);
  const [editData, setEditData] = useState(null);
  const [row, setRow] = useState(null);
  const [deleteComfimationModal, setDeleteComfimationModal] = useState(false);
  const [categoryNameOptions, setCategoryNameOptions] = useState([]);
  const { control, watch, register, reset } = useForm({
    defaultValues: {
      searchCatgory: null,
    },
  });

  const handleReset = () => {
    reset();
  };

  const searchCatgoryValue = watch("searchCatgory");
  const populatetable = (forPagination) => {
    let tempObj = {
      searchString: searchCatgoryValue ? searchCatgoryValue.label : "",
      page: !forPagination ? 0 : page,
      size: rowsPerPage,
      searchId: searchCatgoryValue ? searchCatgoryValue.id : null,
      menuId: null,
    };
    setShowSpinner(true);
    getComplaintServicesList(tempObj)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200) {
          if (forPagination) {
            setComplaintCategoryList((prevData) => [
              ...prevData,
              ...res.result,
            ]);
            setShowSpinner(false);
          } else {
            setComplaintCategoryList(res.result);
            setShowSpinner(false);
          }
          setCount(res.count);
          setShowSpinner(false);
        } else {
          setShowSpinner(false);
          errorAlert(res.message);
        }
      })
      .catch((error) => {
        setShowSpinner(false);
        errorAlert(error.message);
      });
  };

  const handleDelete = () => {
    setOpenBackdrop(true);
    setShowSpinner(true);
    console.log("kldsjdlkfsldjkfjsdjfsdjfjskld", row);

    getComplaintCategoryDeleteById(row?.Id)
      .then((response) => response.data)
      .then((res) => {
        if (res?.statusCode === 202) {
          setPage(0);
          setShowSpinner(false);
          successAlert(res.message);
          populatetable();
          setDeleteComfimationModal(false);
          setOpenBackdrop(false);
          setSelectedRow(null);
        }
      })
      .catch((errors) => {
        errorAlert(errors.message);
        setDeleteComfimationModal(false);
        setOpenBackdrop(false);
        setOpeComplaiServicesModel(false);
        setSelectedRow(null);
      });
  };

  function renderActions(row, index) {
    console.log("sdkflsdjfjsdkjfsdjlfsdfs", row);

    return (
      <div className="flex gap-2" key={index}>
        {userActions.map((action) => (
          <>
            {action.isAction && action.permission === "Edit" ? (
              <button
                onClick={() => {
                  setRow(row?.Id);
                  setOpeComplaiServicesModel(true);
                  setEdit(true);
                }}
              >
                <EditIcon type="button" title="Edit" />
              </button>
            ) : null}
            {action.isAction && action.permission === "Delete" ? (
              <button
                onClick={() => {
                  setDeleteComfimationModal(true);
                  setRow(row);
                }}
              >
                <DeleteIcon title="Delete" type="button" />
              </button>
            ) : null}
          </>
        ))}
      </div>
    );
  }
  useEffect(() => {
    populatetable();
  }, []);

  const renderInput = (row, index, header) => {
    return (
      <>
        {header === "Is Assest Link" && ( 
          <p>{row?.["Is Assest Link"] ? "Yes" : "No"}</p>
        )}
      </>
    );
  };

  useEffect(() => {
    if (row !== null) {
      console.log("Selected Row:", row);
      getComplaintServicesFindById(row.Id)
        .then((response) => response.data)
        .then((res) => {
          const newMenuList = res.result;
          console.log("Fetched Edit Data:", newMenuList);
          setEditData(newMenuList);
        })
        .catch((error) => {
          errorAlert(error.message);
        });
    }
  }, []);

  return (
    <div className="mt-12">
      <div className="px-6 space-y-2">
        <div className="flex justify-center font-bold text-xl my-2 px-3">
          Complaint Services
        </div>
        <div className="grid lg:grid-cols-3 md:grid-cols-1 gap-2">
          <div className=" text-start">
            <SearchDropdown
              placeholder="Search Complaint Services "
              name="searchCatgory"
              control={control}
              dataArray={categoryNameOptions}
              searchIcon={true}
              isClearable={true}
              handleInputChange={(e) => {
                if (e !== "" && UseCheckConsecutiveCharacters(e)) {
                  getSearchComplaintServices(e)
                    .then((response) => response.data)
                    .then((response) => {
                      if (
                        response.statusCode === 200 ||
                        response.statusCode === 204
                      ) {
                        console.log("canteen Name", response?.result);
                        setCategoryNameOptions(response.result);
                      }
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                } else {
                  setCategoryNameOptions([]);
                }
              }}
            />
          </div>
          <div className="flex justify-start gap-2">
            <CommonButton
              searchIcon={true}
              onClick={populatetable}
              type="button"
              className="bg-[#073763] text-white"
            />
            <CommonButton
              label="Reset"
              type="button"
              className="bg-white text-[#D11A2A] border border-[#D11A2A]"
              onClick={handleReset}
            />
          </div>
          {userActions.map((actions) => (
            <>
              {!actions.isAction && actions.permission === "Create" ? (
                <>
                  <div className="flex justify-end">
                    <CommonButton
                      type="button"
                      label="+ New"
                      className="modelOpenButton bg-[#073763]  text-white"
                      onClick={() => {
                        setRow(null);
                        setOpeComplaiServicesModel(true);
                        setEdit(false);
                      }}
                    />
                  </div>
                </>
              ) : null}
            </>
          ))}
        </div>
        {spinner ? (
          <div className="grid justify-center items-center pt-0">
            <LoadingSpinner />
          </div>
        ) : (
          <>
            {complaintCategoryList.length > 0 ? (
              <CommonMasterPaginationTable
                dataResult={complaintCategoryList}
                page={page}
                highlightRow={false}
                tableClass="capitalize"
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                count={count}
                setRowsPerPage={setRowsPerPage}
                renderActions={renderActions}
                removeHeaders={[
                  "Id",
                  "deletestatus",
                  "activestatus",
                  "id",
                  "Id",
                  "serviceagent",
                  "Description",
                  "description",
                ]}
                editableColumns={["Is Assest Link"]}
                renderInput={renderInput}
                populateTable={populatetable}
              />
            ) : (
              <>
                {!spinner && (
                  <div className="flex justify-center h-96 items-center font-semibold">
                    No Record Found <span className="animate-pulse">...</span>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
      {opencomplaintServicesModel && (
        <ComplaintServicesModel
          open={opencomplaintServicesModel}
          handleClose={() => {
            setOpeComplaiServicesModel(false);
          }}
          editData={editData}
          setEditData={setEditData}
          row={row}
          edit={edit}
          setEdit={setEdit}
          setRow={setRow}
          setOpenBackdrop={setOpenBackdrop}
          populateTable={populatetable}
          setComplaintCategoryList={setComplaintCategoryList}
          complaintCategoryList={complaintCategoryList}
        />
      )}
      <ConfirmationModal
        confirmationOpen={deleteComfimationModal}
        confirmationHandleClose={() => {
          setDeleteComfimationModal(false);
          setRow(null);
        }}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure  want to Delete this record ?"
        confirmationSubmitFunc={handleDelete}
        confirmationButtonMsg="Delete"
      />
      {openBackdrop && <CommonBackDrop openBackdrop={openBackdrop} />}
    </div>
  );
}
